import {Component, Inject, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CommonService, TranslationService} from 'gast-common-ng';
import {LanguageDto} from 'gast-common-ng/lib/shared/dto/language-dto';
import {AuthService} from 'gast-portal-ng';
import {FooterModel} from 'gast-portal-ng/lib/footer/model/footer-model';
import {HeaderModel} from 'gast-portal-ng/lib/header/model/header-model';
import {HeaderStyleModel} from 'gast-portal-ng/lib/header/model/header-style-model';
import {UserModel} from 'gast-portal-ng/lib/header/model/user-model';
import {filter} from 'rxjs/operators';
import {StylingService} from './shared/services/styling.service';
import {ProductService} from './shared/services/product.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'gast-portal-certificate';
  languages: Array<LanguageDto>;
  headerModel: HeaderModel;
  footerModel: FooterModel;
  headerStyle: HeaderStyleModel;
  productStyle: SafeResourceUrl;
  env: any;

  currentRoute: string;
  username: string;

  constructor(
    public productService: ProductService,
    private translationService: TranslationService,
    private translateService: TranslateService,
    private authService: AuthService,
    private router: Router,
    private languageService: CommonService,
    private stylingService: StylingService,
    public sanitizer: DomSanitizer,
    @Inject('env') private envConfig: any
  ) {
    this.env = this.envConfig.callback(this.envConfig.value);
    this.footerModel = this.stylingService.generateProductFooter();

    this.headerModel = this.stylingService.generateProductHeaderModel(this.languages);
    this.headerStyle = this.stylingService.generateProductHeaderStyleModel();
  }

  ngOnInit(): void {
    // subscribe to language change
    this.translateService.onLangChange.subscribe(event => {
      this.headerModel = this.stylingService.generateProductHeaderModel(this.languages);
      this.footerModel = this.stylingService.generateProductFooter();
    });

    this.languageService.languagesLoaded.subscribe(languages => {
      this.languages = languages;
      if(!this.translateService.currentLang) {
        this.translateService.currentLang = 'de';
      }
      this.headerModel = this.stylingService.generateProductHeaderModel(this.languages);
    });

    this.productService.productSelected.subscribe(() => {
      this.headerModel = this.stylingService.generateProductHeaderModel();
      this.headerStyle = this.stylingService.generateProductHeaderStyleModel();
      this.footerModel = this.stylingService.generateProductFooter();
      this.productStyle = this.sanitizer.bypassSecurityTrustResourceUrl(this.stylingService.getProductStyles());
      this.setFavicon();
    });

    // callback for query parameter
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((navEnd: NavigationEnd) => {
      if(this.getUserModel() && this.getUserModel().username) {
        this.username = this.getUserModel().username;
      }
      this.currentRoute = navEnd.url;
      this.productService.checkProduct();
    });
  }

  logoPressed(): void {
    window.location.href = 'https://www.testdaf.de';
  }

  onLanguageChanged(languageCode: string): void {
    this.translationService.changeLanguageUsingCode(languageCode);
  }

  private setFavicon() {
    const favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    favIcon.href = this.stylingService.getFaviconLink();
  }

  // *********************** OTHER *****************************
  getUserModel(): UserModel {
    const userDto = this.authService.readUserInfo();
    return userDto ? {username: userDto.username} as UserModel : null;
  }

}
